import { IconUser, IconBook } from "@arco-design/web-react/icon";

type RoleSelectCardProps = {
  role: "mentor" | "mentee";
  selected: boolean;
  title: string;
  description: string;
  onSelect: () => void;
};

export const RoleSelectCard = ({
  role,
  selected,
  title,
  description,
  onSelect,
}: RoleSelectCardProps) => {
  return (
    <button
      type="button"
      className={`auth-role-card${selected ? " auth-role-card--selected" : ""}`}
      onClick={onSelect}
      aria-pressed={selected}
    >
      <div className="auth-role-card__icon">
        {role === "mentor" ? <IconUser /> : <IconBook />}
      </div>
      <div>
        <p className="auth-role-card__title">{title}</p>
        <p className="auth-role-card__desc">{description}</p>
      </div>
    </button>
  );
};
